export function accountDisplayName(user) {
  const fullName = [user?.first_name, user?.last_name].filter(Boolean).join(" ").trim();
  return (
    user?.preferred_name?.trim()
    || user?.display_name?.trim()
    || fullName
    || user?.name?.trim()
    || user?.email?.split("@")[0]
    || "Traveler"
  );
}

function composeFullName(firstName, lastName) {
  const first = firstName?.trim() || "";
  const last = lastName?.trim() || "";
  if (!first) return last;
  if (!last) return first;
  const firstKey = first.toLocaleLowerCase();
  const lastKey = last.toLocaleLowerCase();
  if (firstKey === lastKey || firstKey.endsWith(` ${lastKey}`)) return first;
  if (lastKey.startsWith(`${firstKey} `)) return last;
  return `${first} ${last}`;
}

export function accountFullName(user) {
  const hasStructuredFullName = Boolean(user?.first_name?.trim() && user?.last_name?.trim());
  const profileFullName = hasStructuredFullName
    ? composeFullName(user?.first_name, user?.last_name)
    : "";
  return (
    profileFullName
    || user?.display_name?.trim()
    || user?.name?.trim()
    || user?.preferred_name?.trim()
    || composeFullName(user?.first_name, user?.last_name)
    || user?.email?.split("@")[0]
    || "Traveler"
  );
}

export function accountInitials(user) {
  const name = accountDisplayName(user);
  return name.split(/\s+/).filter(Boolean).map((part) => part[0]).slice(0, 2).join("").toUpperCase() || "?";
}

export function accountAvatarUrl(user) {
  const url = user?.avatar_url;
  if (!url) return null;
  return url.startsWith("/") ? `${process.env.REACT_APP_BACKEND_URL}${url}` : url;
}